import { DefaultToolbar } from 'components/MUIDataGrid/DefaultToolbar/DefaultToolbar';
import { GridToolbarTableViewState } from 'components/pages/finance/shared/FinanseTableMUI/CustomToolbar/GridToolbarTableViewState';

export const CustomToolbar = ({ localStorageTableName, migrateTableState, quickFilterProps, ...restProps }) => {
  return (
    <DefaultToolbar {...restProps} quickFilterProps={quickFilterProps}>
      <GridToolbarTableViewState
        localStorageTableName={localStorageTableName}
        migrateTableState={migrateTableState}
        setQuickFilterExpanded={quickFilterProps.onExpandedChange}
      />
    </DefaultToolbar>
  );
};
